import script from "./BlogMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogMenu.vue?vue&type=script&lang=ts&setup=true"

import "./BlogMenu.vue?vue&type=style&index=0&id=6b481f1f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b481f1f"]])

export default __exports__